/**
 * Safely gets a single property from a multi-property CSS value.
 * @param  {String} value The multi-property value.
 * @param  {String} property The property to grab.
 * @return {String|undefined}
 * @example
 *
 * const transform = 'translate(0, 0) rotate(35deg';
 * console.log(getMultiValueProperty(transform, 'rotate')); // "35deg"
 */
const getMultiValueProperty = (value, property) => {
    if (!value || !property) {
        return;
    }

    const regex = new RegExp(`${property}\\((.*?)\\)`);

    const match = value.match(regex);

    if (!match) {
        return;
    }

    return match[1];
};

export default getMultiValueProperty;
